import React from "react";
import { Image } from "react-bootstrap";
import "../../../assets/css/scss/section/player/_profileStatisticsTopScorerCard.scss";

export default function ProfileStatisticsTopScorerCard(props:any) {
  return (
    <div className="player-profile-section d-flex align-items-end">
      <div className="player-img">
        <h3 className="h5 text-center text-uppercase mb-1">{props?.display_field}</h3>
        <div className="box">
          <Image src={props?.player_image} style={{borderRadius : "50%"}} alt="palyer" fluid />
        </div>
      </div>
      <div className="player-profile-detail">
        <h4 className="font-semibold text-capitalize">{props?.player_name}</h4>
        <p className="h5 text-capitalize">{props?.player_position}</p>
        <p className="h5 mb-0">{props?.display_value}</p>
      </div>
    </div>
  );
}
